import * as React from 'react';

import {TypingDot} from './typing-dot';

import styles from './typing-indicator.module.css';

export const TypingIndicator = () => {
    return (
        <div className={styles['typing-indicator']}>
            <TypingDot animationDelay={0} />
            <TypingDot animationDelay={0.2} marginLeft={true} />
            <TypingDot animationDelay={0.4} marginLeft={true} />
        </div>
    );
};
